export const AB_POPUP_SERVICES_ID = [
    1201, // https://bryk.pl
    1054, // https://deccoria.pl
    1100, // https://biznes.interia.pl
    1077, // https://czateria.interia.pl
    1083, // https://e.sport.interia.pl
    1066, // https://encyklopedia.interia.pl
    1149, // https://film.interia.pl
    1108, // https://geekweek.interia.pl
    1129, // https://gry.interia.pl
    1055, // https://historia.interia.pl
    1023, // https://kobieta.interia.pl
    1060, // https://motoryzacja.interia.pl
    1150, // https://muzyka.interia.pl
    1135, // https://pogoda.interia.pl
    1037, // https://programtv.interia.pl
    1002, // https://styl.interia.pl
    1003, // https://swiatseriali.interia.pl
    1050, // https://wydarzenia.interia.pl
    1106, // https://zdrowie.interia.pl
    1103, // https://zielona.interia.pl
    1041, // https://www.interia.tv
    1200, // https://maxmodels.pl
    1021, // https://www.pomponik.pl
];

export const AB_POPUP_EXT_SERVICES_NAMES = ['teksciory.interia.pl', 'tipy.interia.pl'];
